import { Injectable } from "@angular/core";
import { AsyncSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class Base64ConversionService {

  b64Type(file: File) {
    if (file?.name) {
      const name: string = file.name.toString();
      switch (true) {
        case name.includes(".pdf"):
          return "data:application/pdf;base64,";
        case name.includes(".png"):
          return "data:image/png;base64,";
        case name.includes(".jpg"):
          return "data:image/jpg;base64,";
        case name.includes(".doc"):
          return "data:application/msword;base64,";
        case name.includes(".docx"):
          return "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
        case name.includes(".pptx"):
          return "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,";
        case name.includes(".csv"):
          return "data:text/csv;base64,";
        default:
          return "data:text/plain;base64";
      }
    }
    return "data:text/plain;base64";
  }

  downloadB64File(b64String: string, fileName: string) {
    const downloadLink = document.createElement("a");
    downloadLink.className = "download-link";
    downloadLink.href = window.URL.createObjectURL(this.base64toBlob(b64String));
    if (b64String) {
      downloadLink.setAttribute("download", fileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  }

  base64toBlob(base64Data: string): Blob {
    const contentType = "";
    const sliceSize = 512;
    const byteCharacters = atob(base64Data.substr(base64Data.indexOf(",") + 1));
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  fileToBase64(file) {
    const fileReader = new FileReader();
    const result = new AsyncSubject<string>();
    fileReader.readAsBinaryString(file);
    fileReader.onload = (event) => {
      result.next(btoa(event.target.result.toString()));
      result.complete();
    };
    return result;
  }

  fileToReadAsText(file) {
    const fileReader = new FileReader();
    const result = new AsyncSubject<string>();
    fileReader.readAsBinaryString(file);
    fileReader.onload = (event) => {
      result.next(event.target.result.toString());
      result.complete();
    };
    return result;
  }
}
